export const messageStorageExternalSteps = [
  {
    selector: "#client-details-header",
    content:
      "View key client information, including Client Name, Client ID, and Storage Entitlement. Storage Entitlement shows your allocated quota (GB) and current usage.",
  },
  {
    selector: "#message-storage-date-picker",
    content:
      "Select a date to view storage data for that day. The default is set to yesterday. You can also choose a Compare with Date to view changes between two dates side by side.",
  },
  {
    selector: "#message-storage-search-button",
    content:
      "Click Search to retrieve storage data for the selected date or date range.",
  },
  {
    selector: "#message-storage-reset-button",
    content:
      "Click Reset to clear your selections and restore the default date values.",
  },
  {
    selector: "#message-storage-summary",
    content:
      "After running a search, view the total storage usage across your environments or channels.",
  },
  {
    selector: "#message-storage-data-grid",
    content:
      "Review detailed storage data in this table. Click a row to drill down into more granular views, from environments to channels to daily breakdowns.",
  },
];
